import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';


@Component({
	selector: 'app-blood-gas-sample-item',
	templateUrl: './blood-gas-sample-item.component.html',
	styleUrls: ['./blood-gas-sample-item.component.scss'],
	imports: [ItemContentComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasSampleItemComponent implements SheetItemComponentBase {

	@Input() row!: Row;
	@Input() startLabel!: string;
	@Input() endLabel!: string;

	constructor() {
	}
}